var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingPageCiteIcon = function SvgLandingPageCiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 51,
    fill: "none",
    viewBox: "0 0 31 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LandingPageCiteIcon_svg__a)",
    fillRule: "evenodd",
    d: "M22.896 29.125C27.723 26.5 31 21.382 31 15.5 31 6.94 24.06 0 15.5 0S0 6.94 0 15.5c0 6.027 3.44 11.25 8.463 13.814v15.25l7.216-8.165 7.217 8.165zM11.463 31.19h-.021v-3.863C6.53 25.641 3 20.983 3 15.5 3 8.596 8.596 3 15.5 3S28 8.596 28 15.5c0 5.362-3.376 9.936-8.12 11.71v3.162l.016-.004v6.271l-4.217-4.77-4.216 4.77z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LandingPageCiteIcon_svg__a",
    x1: 0,
    x2: 41.824,
    y1: 0,
    y2: 35.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#fff",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgLandingPageCiteIcon;